// extracted by mini-css-extract-plugin
module.exports = {"primaryButton":"LoginCardsGroup-primaryButton-3NMlF_","emptyState":"LoginCardsGroup-emptyState-2CnCHI"};